import Component from "@glimmer/component";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { concat } from "@ember/helper";
import DSelect from "discourse/ui-kit/d-select";
import { i18n } from "discourse-i18n";

export default class CommunityFeedbackComposerFields extends Component {
  @service composer;

  get visible() {
    return Boolean(this.model.communityFeedbackItemType);
  }

  get model() {
    return this.args.outletArgs.model;
  }

  get games() {
    return this.model.communityFeedbackGames || [];
  }

  get i18nPrefix() {
    return this.model.communityFeedbackItemType === "wish"
      ? "community_feedback.wishes.composer"
      : "community_feedback.composer";
  }

  @action
  selectGame(gameKey) {
    this.composer.disableSubmit = !gameKey;
    this.model.setProperties({
      communityFeedbackGameKey: gameKey,
      communityFeedbackCustomFields: gameKey
        ? { community_feedback_game_key: gameKey }
        : {},
    });
  }

  <template>
    {{#if this.visible}}
      <div class="community-feedback-composer-field" ...attributes>
        <label
          class="community-feedback-composer-field__label"
          for="community-feedback-game"
        >
          {{i18n (concat this.i18nPrefix ".game")}}
        </label>
        <DSelect
          id="community-feedback-game"
          class="community-feedback-composer-field__control"
          @value={{this.model.communityFeedbackGameKey}}
          @nonePlaceholder={{i18n
            (concat this.i18nPrefix ".game_placeholder")
          }}
          @onChange={{this.selectGame}}
          required
          as |select|
        >
          {{#each this.games as |game|}}
            <select.Option @value={{game.key}}>{{game.name}}</select.Option>
          {{/each}}
        </DSelect>
      </div>
    {{/if}}
  </template>
}
